<template>
  <div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div slot="title" class="dialog-title">
        <h4>试题设置</h4>
        <div class="dialogclose">
          <img
            src="@/assets/dialogimg/dialogclose.png"
            alt=""
            @click="cancel"
          />
        </div>
      </div>
      <div class="dialog-body" v-loading="loading">
        <div class="testtypebutton">
          <!-- 切换按钮 -->
          <button
            class="testtypebtn"
            :class="{ isactivetype: testtype === '1' }"
            @click="changetesttype('1')"
          >
            平台题库
          </button>
          <!-- <button
            class="testtypebtn"
            :class="{ isactivetype: testtype === '0' }"
            @click="changetesttype('0')"
          >
            自定义题库
          </button> -->
        </div>
        <!-- 穿梭框选择题库功能 -->
        <div class="question_contents">
          <div class="questions">
            <div class="resreach">
              <el-input v-model="input" placeholder=""></el-input>
            </div>
            <el-cascader-panel
              :options="option"
              :props="props"
              v-model="val"
              ref="cascader"
              clearable
              @change="changda($event)"
              class="taansfer"
            ></el-cascader-panel>
          </div>
          <!-- <div class="question">
            <img src="../../../../../../assets/transferbtn.png" alt="" />
          </div>
          <div class="questions">
            <div class="resreach">
              <el-input
                v-model="input"
                placeholder="暂时先用这个吧1，后边再改"
              ></el-input>
            </div>
            <el-cascader-panel
              :options="vals"
              :props="props2"
              v-model="val"
              ref="cascader"
              clearable
            ></el-cascader-panel>
          </div> -->
        </div>
        <div class="operation_btn">
          <el-button type="success" @click="back">取消</el-button>
          <el-button type="primary" @click="submita">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//import totype from "@/utils/transfer";
import { authAppSave, authApp } from "@/api/permissions.js";
import loginvuex from "@/store/index";
import qs from "qs";
export default {
  data() {
    return {
      dialogVisible: false,
      testtype: "1",
      isdialogVisible: "", //打开题库弹窗时的状态。1代表是在权限管理里面打开
      input: "",
      props: {
        multiple: true,
        value: "AppClassID",
        label: "AppClassName",
        emitPath: false,
      }, //是否多选 左边
      val: [], //选中的数据
      option: [],
      loading: true,
      options: [
        {
          value: 1,
          label: "东南",
          children: [
            {
              value: 2,
              label: "上海",
              children: [
                { value: 3, label: "普陀" },
                { value: 4, label: "黄埔" },
                { value: 5, label: "徐汇" },
              ],
            },
            {
              value: 7,
              label: "江苏",
              children: [
                { value: 8, label: "南京" },
                { value: 9, label: "苏州" },
                { value: 10, label: "无锡" },
              ],
            },
            {
              value: 12,
              label: "浙江",
              children: [
                { value: 13, label: "杭州" },
                { value: 14, label: "宁波" },
                { value: 15, label: "嘉兴" },
              ],
            },
          ],
        },
        {
          value: 17,
          label: "西北",
          children: [
            {
              value: 18,
              label: "陕西",
              children: [
                { value: 19, label: "西安" },
                { value: 20, label: "延安" },
              ],
            },
            {
              value: 21,
              label: "新疆维吾尔族自治区",
              children: [
                { value: 22, label: "乌鲁木齐" },
                { value: 23, label: "克拉玛依" },
              ],
            },
          ],
        },
      ],
    };
  },
  methods: {
    changda(e) {
      //选中节点的值
      console.log(e);
      //   console.log(this.$refs["cascader"].getCheckedNodes());
      //   this.vals = totype.zhuanhuan(this.val);
      console.log(this.val);
    },
    cancel() {
      this.dialogVisible = !this.dialogVisible;
    },
    // softapprrefer(soft) {
    //   let first = {};
    //   first[soft[0].label + "|" + soft[0].AppClassID] = {};
    //   soft[0].children.map((item) => {
    //     first[soft[0].label + "|" + soft[0].AppClassID][
    //       item.label + "|" + item.AppClassID
    //     ] = [];
    //     let threed = item.children.map((items) => {
    //       return (
    //         items.AppEName +
    //         "|" +
    //         items.AppID +
    //         "|" +
    //         items.label +
    //         "|" +
    //         item.label +
    //         "|" +
    //         item.AppClassID
    //       );
    //     });
    //     first[soft[0].label + "|" + soft[0].AppClassID][
    //       item.label + "|" + item.AppClassID
    //     ].push(threed);
    //   });
    //   return first;
    // },
    changetesttype(type) {
      if (this.testtype !== type) {
        if (this.testtype === "1") {
          this.testtype = "0";
        } else {
          this.testtype = "1";
        }
      }
    },
    back() {
      this.dialogVisible = false;
    },
    // submit() {
    //   //  console.log("ssss");
    //   if (this.val.length !== 0) {
    //     console.log(" 选择好了数据", this.val.length);
    //     this.dialogVisible = false;
    //   } else {
    //     this.$message({
    //       message: "必须要勾选一个题库",
    //       type: "warning",
    //     });
    //     return;
    //   }
    //   this.$parent.isaddtest = false;
    //   let selectarr = []; //发送的数据
    //   const clonearr = JSON.stringify(this.option[0]);
    //   const afterclonearr = JSON.parse(clonearr);
    //   selectarr.push(afterclonearr); //第一层数据
    //   selectarr[0].children = [];
    //   //  console.log(selectarr);
    //   // console.log(this.option[0].children.length);
    //   //先改造第一层数据 ，第一层数据默认为一个，暂时不改造。
    //   //直接开始改造第二级的数据。 过滤掉第二级选中的第三级别数据
    //   // console.log("ssss");
    //   // console.log(this.option[0].children.length);
    //   // console.log(this.vals[0].children);
    //   this.vals[0].AppClassID = this.option[0].AppClassID;
    //   console.log(this.vals);
    //   for (let i = 0; i < this.option[0].children.length; i++) {
    //     //   console.log('第'+i+'大圈开始--------------------------------------');
    //     let a = this.vals[0].children.filter((item, index) => {
    //       //  console.log("第" + index + "二圈开始~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~");
    //       //这里面改造第三级别的数据了。
    //       //  console.log(this.option[0].children[i].children.length);
    //       // 开始第三圈
    //       if (this.option[0].children[i].AppClassName === item.label) {
    //         item.AppClassID = this.option[0].children[i].AppClassID;
    //         for (
    //           let b = 0;
    //           b < this.option[0].children[i].children.length;
    //           b++
    //         ) {
    //           //  console.log('第'+b+"三圈开始=========================================");
    //           item.children.map((zitem) => {
    //             //   console.log(i+'?===================='+b);
    //             //   console.log(this.option[0].children[i].children[b].AppClassName);
    //             //   console.log(zitem.label);
    //             //console.log('结束');
    //             if (
    //               this.option[0].children[i].children[b].AppClassName ===
    //               zitem.label
    //             ) {
    //               //     console.log(i+'?===================='+b);
    //               //  console.log(this.option[0].children[i].children[b].AppEName );
    //               zitem.AppEName =
    //                 this.option[0].children[i].children[b].AppEName; //因为赋值到这里是对的。用户名
    //               zitem.AppID = this.option[0].children[i].children[b].AppID; //赋予ID
    //               zitem.AppName =
    //                 this.option[0].children[i].children[b].AppName; //赋予ID
    //             }
    //           });
    //         }
    //       }
    //       // if (i < index || i == index) {
    //       //   for (let z = 0; z < this.vals[0].children[i].children.length; z++) {
    //       //     console.log('需要更改的圈数');
    //       //     // if (
    //       //     //   this.option[0].children[i].children[z].AppClassName ==
    //       //     //   item.children[z].label
    //       //     // ) {
    //       //     //   console.log('需要更改');
    //       //     // }
    //       //   }
    //       // }
    //       return this.option[0].children[i].AppClassName === item.label;
    //     });
    //     //  console.log(a);
    //     if (a.length !== 0) {
    //       selectarr[0].children[i] = a[0];
    //     }
    //   }
    //   console.log(JSON.stringify(this.vals), 22222222222222222222222222);
    //   //过滤传给第一级的数据
    //   let res = this.vals.map((item) => {
    //     return item.children.map((zitem) => {
    //       return zitem.children;
    //     });
    //   });
    //   console.log(res);
    //   res = res.flat(2);
    //   // res.map((item)=>{
    //   //   item.AppName = item.label
    //   // })
    //   //过滤传给第二级的数据
    //   let CookieApp = {};
    //   this.vals.map((item) => {
    //     item.children.map((zitem) => {
    //       CookieApp[`${zitem.label}`] = zitem.children;
    //     });
    //   });
    //   console.log(CookieApp); //智能组卷发送给④步的数据
    //   let softappdata = this.softapprrefer(this.vals);
    //   console.log(JSON.stringify(softappdata));
    //   this.$parent.$parent.softAppdata = softappdata;
    //   this.$parent.$parent.pagetworeq3 = CookieApp;
    //   console.log(res);
    //   this.$emit("totesttype", this.vals, res); //这里不能直接传值，这里的数据类型不够，要重新拼接数据。 但是暂时采用这种办法，这只是把视觉上的数据传值过去了，但是没有传APPClassID和AppClassName过来。
    //   //  console.log(selectarr[0].children); //到这里，第二层数据已经改造ok。
    //   const arr = [];
    //   selectarr[0].children.forEach((item) => arr.push(item));
    // },
    submita() {
      let parmas = {
        studentUserID: this.$parent.$parent.currentRow.userid,
        appArr: JSON.stringify(this.val),
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        hid: JSON.parse(loginvuex.state.hid),
      };
      authAppSave(qs.stringify(parmas));
      this.$message.success("保存成功");
      this.dialogVisible = false;
    },
    async settestscope() {
      const itemRow = this.$parent.$parent.currentRow;
      let obj = {
        hid: JSON.parse(loginvuex.state.userlist).hid,
        // studentUserID: itemRow.userid, //这里先写一个假的
        studentUserID:JSON.parse(loginvuex.state.userlist).userID, // 此处ID修改成管理员ID，因后端查询有问题
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
      };
      this.loading = true;
      const { data } = await authApp(obj);
      if (data.Status == 200) {
        this.option = []; //还原初始数据。
        // let resa = JSON.parse(localStorage.getItem("alltestbank"));
        let resa = data.Data;
        resa.map((item) => {
          item.children.map((items) => {
            items.children.map((itemz) => {
              itemz.AppClassID = itemz.AppID;
            });
          });
        });
        // resa = this.filterArrByObj(resa, 1, "children", "isOpen") // 过滤掉 isOpen==0
        this.option = resa;
        setTimeout(() => {
          this.loading = false;
        }, 500);
        // return;
      } else {
        this.$message.error(data.Msg);
      }
    },
    filterArrByObj(arr, commonValue, childList, commonKey) {
      let arrCopy = [];
      arr.forEach((ele) => {
        if (ele[commonKey] === commonValue) {
          arrCopy.push(ele);
          if (ele[childList]) {
            this.filterArrByObj(
              ele[childList],
              commonValue,
              childList,
              commonKey
            );
          }
        }
      });
      let num = arr.length;
      arrCopy.forEach((ele) => {
        arr.push(ele);
      });
      for (let i = 0; i < num; i++) {
        arr.shift();
      }
      return arrCopy
    },
  },
  created() {
    this.settestscope();
  },
  mounted() {
    //  this.vals = totype.zhuanhuan(this.val);
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-cascader-node__label {
  white-space: normal;
}
::v-deep .el-cascader-node {
  height: 100%;
  padding: 10px;
}
::v-deep .el-dialog {
  width: 80%;
  min-width: 1572px;
  background: #ffffff;
  border: 1px solid #707070;
  border-radius: 20px;
}
::v-deep .el-dialog__header {
  padding: 0 !important;
}
::v-deep .el-dialog__body {
  padding: 0 !important ;
}
.dialog-title {
  display: flex;
  align-items: center;
  height: 55px;
  border-radius: 5px 5px 0px 0px;
  background: linear-gradient(180deg, #64b5ff 0%, rgba(199, 228, 255, 1) 100%);
  h4 {
    margin-left: 30px;
    width: 72px;
    height: 30px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
}
.dialogclose {
  cursor: pointer;
  margin-left: 1430px;
}
.dialog-body {
  background-color: none;
}
.testtypebutton {
  height: 93px;
  background-color: rgb(255, 255, 255);
  //border-bottom: 1px solid #eeeeee;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.testtypebtn {
  width: 180px;
  height: 50px;
  background: #ffffff;
  border: 1px solid #1890ff;
  font-family: PingFang SC;
  border: 1px solid#1890FF;
  border-radius: 5px 0px 0px 5px;
  &:nth-child(2) {
    border-left: none;
    border-radius: 0px 5px 5px 0px;
  }
  //border-radius: 0px 5px 5px 0px;
}
.isactivetype {
  color: #ffffff;
  background-color: #1890ff;
}
.question_contents {
  display: flex;
  .questions {
    width: 49%;
    border-top: 1px solid #abd7ff;
  }
  .question {
    width: 2%;
    height: 480px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .resreach {
    height: 60px;
    font-size: 18px;
    //background: #cce7ff;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    line-height: 60px;
    padding-left: 14px;
  }
}
::v-deep .is-bordered {
  > :nth-child(1) {
    min-width: 250px;
    width: 30%;
    border-right: none;
  }
  > :nth-child(2) {
    min-width: 250px;
    width: 30%;
    border-right: none;
  }
  > :nth-child(3) {
    min-width: 250px;
    width: 33%;
    border-right: none;
  }
}

::v-deep .el-cascader-menu__wrap {
  height: 430px;
}
::v-deep .el-cascader-node {
  height: 52px;
  border-bottom: 1px solid #eeeeee;
  &:focus {
    background: linear-gradient(90deg, #ffffff 0%, #8fcaff 100%);
  }
  &:hover {
    background: linear-gradient(90deg, #ffffff 0%, #8fcaff 100%);
  }
}
::v-deep .el-icon-arrow-right {
  display: none; //向右的箭头隐藏
}
::v-deep .el-cascader-menu__list {
  border-right: 1px solid #eeeeee;
}
::v-deep .in-active-path {
  //更改选中后的属性
  background: linear-gradient(90deg, #ffffff 0%, #8fcaff 100%);
}
.operation_btn {
  display: flex;
  margin-top: 50px;
  justify-content: center;
  align-content: center;
  margin-bottom: 20px;
  .el-button {
    width: 108px;
    height: 50px;
    border-radius: 4px;
  }
  .el-button:nth-child(1) {
    background: #eeeeee;
    border: none;
  }
  .el-button:nth-child(2) {
    background: #1890ff;
    margin-left: 90px;
  }
}
</style>